import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const Item = styled.div`
  background-color: ${props => props.theme.secondaryBackground};
  overflow-y: scroll;
  flex: 1;
  padding: 40px;
`;

const DegreeList = styled.div`
  display: flex;
  margin-bottom: 25px;
  flex-wrap: wrap;
  justify-content: center;
`;

const DegreeItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const Image = styled.img`
  max-height: 600px;
  align-self: center;
  margin-bottom: 20px;
`;

const DegreeTabItem = ({ degrees }) => (
  <Item>
    <DegreeList>
      <DegreeItem>
        {degrees && degrees.map(({ name, fileId, file }) => <Image src={file} alt={name} key={fileId} />)}
      </DegreeItem>
    </DegreeList>
  </Item>
);

DegreeTabItem.propTypes = {
  degrees: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.string.isRequired,
      file: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
};

export default DegreeTabItem;



// WEBPACK FOOTER //
// ./src/components/CoachPanel/Tab/DegreeTabItem/DegreeTabItem.jsx